// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-sidebar {
  width: 280px;
  height: 100vb;
  flex-shrink: 0;

  background: #fff;
  overflow: hidden;
  transition: width 1s ease;
  &.closed {
    width: 64px;
    transition: width 1s ease;
  }
}
.team-invitation-sent {
  padding-left: 14px !important;
}

.closed-sidebar {
  width: 80px;
}
.left-icon {
  cursor: pointer;
}
.sidebar-content {
  background-color: #fff;
  height: calc(100vh - 12.5em);
  overflow: auto;
  padding-bottom: 20px;
  /* scrollbar-width: none; */
  width: 100%;
}
.sidebar-logo {
  padding: 29px 32px;
  cursor: pointer;
}
.side-logo {
  width: 146.673px;
  height: 26px;
  flex-shrink: 0;
}
.inline {
  width: 1px;
  height: 25px;
  background: #e5e9ec;
  margin: 0px 24px;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.common-text {
  color: #405261;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.dashboard-container {
  height: 56px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0px 16px;
  padding: 0px 16px;
}
.dashboard-container-mbl {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  justify-content: center;
  transition: transform 0.3s cubic-bezier(0.4, 0, 1, 2);
  cursor: pointer;
}
.active-class {
  display: flex;
  height: 56px;
  flex-shrink: 0;
  border-radius: 9px;
  background: #f9fafa;
  color: #061522;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin: 0px 16px;
}
.left-sidebar-mbl {
  width: 80px;
  height: auto;
  flex-shrink: 0;
  border-right: 1px solid #e5e9ec;
  background: #fff;
  transition: width 0.3s cubic-bezier(0.4, 0, 1, 2);
}
.footer-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0px 16px;
  height: 48px;
  padding: 0 8px;
  box-sizing: border-box;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  cursor: pointer;
}

.sidebar-profile-avatar-wrap {
  position: relative;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.sidebar-profile-status {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.sidebar-profile-status svg {
  width: 12px;
  height: 12px;
  display: block;
}

.footer-container .arrow {
  margin-left: auto;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.footer-container-logout {
  display: flex;
  align-items: center;
  background: #fff;
  gap: 8px;
}
.weilJenny-container {
  min-width: 0;
  flex: 1;
}
.weilJenny-container-logout {
  margin-left: 0;
  min-width: 0;
  flex: 1;
}
.sidebar-footer {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
  padding: 16px 0px;
  position: fixed;
  bottom: 0;
  z-index: 1;
  width: inherit;
}
.sidebar-footer-logout {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
}
.sidebar-footer-mbl {
  display: flex;
  justify-content: center;
  cursor: pointer;
  height: 48px;
  align-items: center;
  margin: 0px 16px;
}
.jenny {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}
.wilson {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard-header {
  width: 100%;
  align-items: center;
  position: relative;
  z-index: 100;
}

/* People: title + icon sit in main dashboard row (see .dashboard-container01--people) */
.dashboard-container01--people .dashboard-header-left-cluster {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
.people-header-inline-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 12px;
  min-width: 0;
  margin-bottom: 5px;
}
.people-header-inline-heading {
  margin: 0;
  color: #061522;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.people-dashboard-header-extension {
  background: #fff;
  padding: 0px 24px 0 24px;
}
.people-header-tabs-shell {
  border-bottom: 1px solid #eef2f6;
}
.people-header-tabs-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-end;
}
.people-header-tab-item {
  background: none;
  border: none;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #405261;
  padding: 10px 0 11px;
  margin-bottom: -1px;
  border-bottom: 2px solid transparent;
}
.people-header-tab-item:hover {
  color: #061522;
}
.people-header-tab-item-active {
  color: #061522;
  font-weight: 600;
  border-bottom-color: #148dfd;
}
.user-detail-btn {
  width: 144px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin-top: -6px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 15px;
  margin-left: 16px;
  cursor: pointer;
}
.user-detail-btn:not(:disabled):hover {
  background-color: #ffffff;
  border-color: #c5ced6;

  outline: none;
}
.dashboard-container01 {
  display: flex;
  justify-content: space-between;
  padding: 20px 24px 24px 24px;
  align-items: center;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(15px);
}
.right-icon {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 101;
}
.right-icon01 {
  align-items: center;
  display: flex;
  gap: 16px;
  position: relative;
  z-index: 101;
}
.right-button {
  width: 168px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.conv-text {
  color: #405261;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 112.5% */
}
.number-con {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background-color: #f1f3f5;
  border-radius: 20px;
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 85.714% */
  align-items: center;
  display: flex;
  justify-content: center;
}
.left-sidebar.closed .dashboard-container {
  margin: 0px 8px;
  padding: 0px 8px;
  justify-content: center;
  gap: 0;
}
.left-sidebar.closed .sidebar-logo {
  padding: 29px 8px;
  display: flex;
  justify-content: center;
}
.dashboard-container.active {
  flex-shrink: 0;
  border-radius: 9px;
  background: #f9fafa;
  height: 56px;
  cursor: pointer;
  margin: 0px 16px;
  padding: 0px 16px;
}
.common-text.active {
  color: #061522;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.dashboard-container-mbl.active {
  background-color: #e0e0e0;
  color: #007bff;
}

.Main-Chart-Container {
  display: flex;
  height: 120px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
}

.overview_main {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.Main-Header-Container {
  height: 120px;
}
.Main-chart {
  height: 120px;
  /* padding: 16px 24px; */
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  /* border-right: 1px solid #e5e9ec; */
}
.Dot {
  border-radius: 50px;
  background: #148dfd;
  width: 8px;
  height: 8px;
  flex-shrink: 0;
}

.customer_main_Text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-left: 2px;
}
.number-text {
  color: #061522;
  font-size: 44px;
  line-height: 54px;
  font-style: normal;
  font-weight: 500;
}
.chart-data {
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
  align-items: center;
}
.percentage-class {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: #148dfd;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.percentage-class-error {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: red;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.week-class {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

/* chartStyles.css */
.chart-container {
  background-color: lightblue;
}

.stacked-chart-container {
  background-color: lightgreen;
}
.NewChat-Container {
  width: 50%;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 20px;
}
.NewEmail-Container {
  flex-shrink: 0;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 20px;
}
.userchat-name {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.user-chat {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.timeclass {
  color: #061522;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
}
.NewChat-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.BaseText {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
}
.ViewText {
  color: #148dfd;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  text-decoration-line: underline;
  cursor: pointer;
}
.newChat-text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.chatBottom {
  /* width: 496px; */
  height: 1px;
  margin-right: 10px;
  background: #e5e9ec;
}
.newChat-li {
  display: flex;
  list-style-type: none;
  padding: 16px 10px;
  align-items: center;
}
.arrow {
  transition: transform 0.3s ease;
}

.rotate-arrow {
  transform: rotate(180deg);
}
.Knwoledge-li {
  display: flex;
  list-style-type: none;
  padding: 16px 10px;
  align-items: center;
}
.Knwoledge-name {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.Knwoledge-text {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}
.user-description {
  margin: 14px 0px;
}
.text-description {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.newEmail-li {
  display: flex;
  list-style-type: none;
  padding: 16px 0px;
  margin-right: 10px;
}
.UserNameChat {
  display: flex;
  flex-direction: column;
}
.UserNameEmail {
  display: flex;
  flex-direction: column;
}

.UserMainChat {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 8px;
  margin-top: 5px;
}
.UserMainEmail {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 8px;
  margin-top: 5px;
}
.UserMainknowledge-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 8px;
  margin-top: 5px;
  align-items: center;
}
.Knowledge-container {
  width: 50%;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 20px;
}
.knowledge-container01 {
  margin-top: 27px;
  border-bottom: 1px solid #e5e9ec;
}
.table-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 9px;
}

.table-text {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.table-modified {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-left: 140px;
}

.table-text modified {
  margin-left: 20px;
}

.css-sxh3gq-MuiAvatar-root-MuiAvatarGroup-avatar {
  background-color: #d6edff !important;
  color: #148dfd !important;
}

.Customer-satisfication {
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
  flex-grow: 1;
}
.customer-text {
  display: flex;
  justify-content: space-between;
}
.customer_heading {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
}
.last-message-text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.customer-link {
  color: #148dfd;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  text-decoration-line: underline;
}
.Circular-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 20vh;
  overflow: auto;
}
.circle-text {
  color: #405261;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  margin-top: 8px;
}

.LinearProgress-container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
  flex-grow: 1;
}
.ticket-container {
  display: flex;
  justify-content: space-between;
}
.Dot {
  border-radius: 50px;
  background-color: #007bff;
  width: 8px;
  height: 8px;
}
.linearProgressBar {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 116.667% */
  margin-top: 18px;
  margin-bottom: 9px;
}
.LinearText {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.issues-text {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.viewIssues-text {
  color: #148dfd;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-decoration-line: underline;
}
.statusButton-open {
  border-radius: 5px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  padding: 4px 8px;
  flex-shrink: 0;
  text-align: center;
}
.statusButton-close {
  border-radius: 5px;
  border: 1px solid #ff4d4f;
  background: #fff1f0;
  padding: 4px 8px;
  flex-shrink: 0;
  text-align: center;
}
.statusButton-pending {
  border-radius: 5px;
  border: 1px solid #fadb14;
  background: #fffbe6;
  padding: 4px 12px;
  flex-shrink: 0;
  text-align: center;
}
.jacob-class {
  display: flex;
  gap: 8px;
  align-items: center;
}
.jacob-text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.jacob-des {
  color: #556575;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.jacob-container {
  display: flex;
  flex-direction: column;
}
.jones-container {
  display: flex;
  gap: 8px;
  align-items: center;
}
.devon-lane {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.Header-cell {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.Ticket-Section-Container {
  width: 100%;
  margin: 0px 0px;
  padding: 0px 24px;

  /* height: calc(100vh - 15.5em); */
  display: flex;
  flex-direction: column;
  /* height: calc(100vh - 21.3em); */
}
.Team-Section-Content-Container {
  /* margin: 38px 0px; */
  /* height: calc(100vh - 18.3em); */
  overflow-y: auto;
}
.Team-main-table-container {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.table-header-cell {
  text-align: left;
  border-bottom: 1px solid #e5e9ec;
}
.team-table-img {
  display: flex;
  align-items: center;
  gap: 8px;
}
.table-header-cell th {
  padding-bottom: 9px;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.dashboardheader-right-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tbodyClass01 tr:hover {
  border-collapse: collapse;
  border-spacing: 0;
  background-color: #f9fafa;
}
.team-table-tr td {
  padding: 16px 0;
  border-bottom: 1px solid #e5e9ec;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  position: relative;
  cursor: pointer;
}
.users-table-tr td {
  width: 19%;
}
.ticket-table-tr td {
  padding: 16px 0px;
  border-bottom: 1px solid #e5e9ec;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  position: relative;
  cursor: pointer;
}
.team-table-rowtext {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.team-activeuser {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #061522;
  font-weight: 500;

  cursor: pointer;
}
.team-table-menu {
  font-weight: 600;
  cursor: pointer;
  font-size: 18px;
  margin-bottom: 10px;
}
.team-main-menu-container {
  position: fixed;
  width: 184px;
  right: 30px;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  max-height: 300px;
  /* overflow-y: auto;  */
  padding: 25px;
}
.menu-viewprofile {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
}

.Team-Main-SideBar {
  position: fixed;
  right: 0px;
  top: 0;
  width: 33em;
  height: 100vh;
  /* overflow: auto; */
  background: #fff;
  box-shadow: 0px 4px 80px 0px rgba(6, 21, 34, 0.1);
  padding: 32px;
  transition: transform 0.3s ease;
  z-index: 9999;
}

.Team-Main-SideBar--open {
  transform: translateX(0);
}
.Team-Main-SideBar--closed {
  transform: translateX(-100%);
}
.SideBar-Content-Container {
  max-height: calc(100vh - 260px);
  overflow: auto;
}

.GroupSide-Content-Container {
  max-height: calc(100vh - 200px);
  overflow: auto;
}
.detail-text {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.Team-SideBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Team-sidebar-profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0px;
}
.Team-sidebar-profile-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0px;
}
.Team-logo-profile {
  display: flex;
  align-items: center;
  gap: 8px;
}
.Team-logo-profile-group {
  display: flex;
  align-items: center;
  gap: 17px;
}
.agent-button {
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  border-radius: 5px;
  height: 24px;
  min-width: 64px;
  padding: 0px 2px;
  /* width: 100%; */
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);

  cursor: pointer;
}

.agent-button:not(:disabled):hover {
  border-color: #c5ced6;
  outline: none;
}
.Robert-Fox {
  color: #061522;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 18px; /* 112.5% */
}
.TeamClose-btn {
  cursor: pointer;
}
.Nathan-Fox {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.profile-linestyle {
  border-bottom: 1px solid #e5e9ec;
  background: #fff;
  width: 100%;
}
.team-profile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
.team-profile-list {
  display: flex;
  gap: 8px;
  cursor: pointer;
  padding-bottom: 8px;
}
.profile-header-text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.ProfileActive {
  color: #148dfd;
  border-bottom: 1px solid #148dfd;
  cursor: pointer;
  padding-bottom: 8px;
}
.ProfileActive .profile-header-text {
  color: #148dfd;
}
.AccountType-Main-Container {
  margin-top: 41px;
}
.AccountType-Main-Container01 {
  margin-top: 26px;
}
.AccountType-content {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}

.Account-Type01 {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 50%;
}
.AccountType-text {
  color: #405261;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 112.5% */
}
.AccountAgent-text {
  color: #061522;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 112.5% */
}
.TicketTag {
  border-radius: 16px;
  border: 1px solid #c5ced6;
  background: #f9fafa;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 8px;
  color: #405261;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
}
.SuperVisor-Main-Container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
}
.SuperVisor-Header-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.SuperVisorText {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
}
.SuperVisorChange {
  color: #148dfd;
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}

.CC-Remove {
  color: #ff4d4f;
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}

.SuperVisor-Logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 22px;
}
.Super-Robert-text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.Super-Kenzi-text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.SuperVisor-Container {
  margin-top: 32px;
}
.AssignChat-Main-Container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
}
.AssignChat-Header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.AssignChat-text {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
}
.AssignChat-View {
  color: #148dfd;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  text-decoration-line: underline;
  cursor: pointer;
}
.TeamAssign-Container {
  margin-top: 30px;
}

.Assign-Chat-Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;
}
.AssignChat-button {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 30px;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}

.AssignChat-button:not(.Mui-disabled):hover {
  border-color: #c5ced6;
  outline: none;
}
.AssignChat-status {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.AssignChat-Style {
  display: flex;
  align-items: center;
  gap: 8px;
}
.AssginKatryn-Text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.AssingKenzi-Text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}

.TableView {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.view-more-text {
  color: #148dfd;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  text-decoration-line: underline;
  cursor: pointer;
}
.Active-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 144px;
  padding: 9px 16px;
  cursor: pointer;
}
.dropdown-container {
  position: relative;
  display: inline-block;
}

.Active-btn:hover {
  background-color: #f9fafa;
}

.dropdown-content {
  position: absolute;
  top: 120%;
  right: 1%;
  width: 184px;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 8px 11px;
  z-index: 1;
}
.dropdown-content-table {
  position: absolute;
  right: 50%;
  width: 184px;
  top: 80%;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 8px 11px;
  z-index: 1;
}
.dropdown-content-table-active {
  position: absolute;
  /* right: 40%; */
  width: 184px;
  top: 80%;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 8px 11px;
  z-index: 1;
}

.dropdown-content-table:hover {
  background: #fff;
}

.dropdown-content ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dropdown-content-table ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dropdown-content-table ul li {
  padding: 9px 10px;
  cursor: pointer;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.dropdown-content-table ul:hover {
  background: #fff;
}
.dropdown-content ul li {
  padding: 9px 10px;
  cursor: pointer;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.dropdown-content ul li:hover {
  background-color: #f5f5f5;
  border-radius: 8px;
  background: #f9fafa;
  color: #061522;
}
.dropdown-content-table ul li:hover {
  background-color: #f5f5f5;
  border-radius: 8px;
  background: #f9fafa;
  color: #061522;
}

.Active-btn:hover + .dropdown-content {
  display: block;
}
.Active-popup-container {
  position: absolute;
  z-index: 1;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 24px;
  width: 32%;
  height: auto;
  z-index: 1;
  right: 0;
  left: 0;
  margin: 0 auto;
}

.Confirm-text {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
}
.Save-active-text {
  margin-top: 5px;
  color: #556575;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}

.active-popup-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 64px;
  align-items: center;
  gap: 8px;
}
.active-cancel-button {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 42px;
  color: #405261;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.active-confirm-button {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 11px 42px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.Team-Group-Main-Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 11px;
}
.Team-Group-Heading {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
}
.Team-Group-Link {
  color: #148dfd;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  text-decoration-line: underline;
}

.Team-Group-Main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0px;
}
.Team-Group-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.group-title01 {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.TeamGroup-Container {
  margin-top: 30px;
}
.hash-container {
  display: flex;
  flex-direction: column;
}
.grouphas-button {
  border-radius: 5px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  width: 48px;
  height: 27px;
  color: #405261;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 150% */
}
.hashtext {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  margin-bottom: 3px;
}
.hashtitle {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.tickettime {
  color: #405261;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.Team-Ticket-Main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 21px 0px;
}

.Team-Ticket01 {
  display: flex;
  gap: 8px;
  justify-content: space-between;
}
.WorkingText {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
  margin-bottom: 22px;
}
.Team-Working-Main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.wokringtitle {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.workingtime {
  color: #405261;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.Team-Working-Main {
  padding: 7px 0px;
}
.Group-Main-Container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
}
.TeamTicket-Main-Container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
}
.TeamWorking-main-container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  padding: 24px;
}
.group-discreption {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.Group-logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.viewmore-logo {
  background: #d6edff;
  border-radius: 20px;
  text-align: center;
  stroke: #fff;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.05));
  width: 40px;
  height: 40px;
  padding: 5px;
  color: #148dfd;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
/* .groupIcon{
  display: flex;
  max-width: 75px;
} */
#tags-outlined {
  padding: 6px;
}
.borderedActive {
  outline: solid 2px;
  outline-color: #1976d2;
}
.MuiOutlinedInput-root {
  /* margin-top: 8px; */
  border-radius: 8px;
}
#multiple-limit-tags {
  padding: 6px;
}
.AutoInput {
  background: #007bff;
  border-radius: 20px;
  /* border: 1px solid #D5DCE1; */
  background: #fff;
  /* box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05); */
}
.AutoInput ::placeholder {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.ChatLimit-Container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 29px;
}
.Chatselect-Input {
  margin-top: 20px;
}
.chatKatryn {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.chatkenzi {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.chatLimit-button {
  display: flex;
  gap: 15px;
  margin-top: 32px;
}
.SendChat-Button {
  margin: auto;
  width: 50%;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.SendChat-Button:not(:disabled):hover,
.SendChat-Button:not(:disabled):focus-visible {
  border-color: #c5ced6;

  outline: none;
}
.SendChat-Button01 {
  margin: auto;
  width: 50%;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  border: none;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}

.SendChat-Button01:hover:not(.Mui-disabled):not(:disabled) {
  background-color: #0077cc;
}

.Team-total-active-user {
  color: #061522;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 100% */
  margin-bottom: 22px;
  display: none;
}

.Delete-group-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.DeleteFile-text {
  margin-top: 28px;
  color: #061522;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.DeleteFile-text01 {
  color: #556575;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin-top: 8px;
  width: 80%;
}
.Deletegroup-delete-container {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
}
.Deletegroup-cancel01 {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 100%;
  height: 40px;
  cursor: pointer;
}
.Deletegroup-cancel01:not(:disabled):hover {
  background-color: #ffffff;
  border-color: #c5ced6;

  outline: none;
}
.Deletegroup-delete01 {
  border-radius: 8px;
  background: #148dfd;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 100%;
  height: 40px;
  border: none;
  cursor: pointer;
}
button.Deletegroup-delete01:not(:disabled):hover {
  background-color: #0077cc !important;
}
#long-button:focus {
  border-color: red;
}

.Logout-Menu-Container {
  border-radius: 8px;
  border: 1px solid #e5e9ec;
  background: #fff;
  box-shadow: none;
  padding: 16px;
  position: fixed;
  left: 16px;
  bottom: 80px;
  width: 256px;
  box-sizing: border-box;
  z-index: 9999 !important;
}
.Logout-switch-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
}
.switch-class {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}
.switch-class:hover {
  color: #061522;
}

.Logout-switch-Dark {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}
.LineClass {
  margin: 17px 0px;
  border: 1px solid #e5e9ec;
  width: 100%;
  margin: 16px 0px;
}
.LogoutText {
  color: #ff4d4f;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}
.Switch-Main-Container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.NoSuspendedAgent-main-Conatiner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: calc(100vh - 25.7em);
}

.Space-Left {
  margin-left: 8px;
  font-weight: 500;
}

.popup-content-wrapper {
  display: flex;
  flex-direction: column;
}

.header-section {
  margin-bottom: 16px;
}

.logout-main-title {
  color: #061522 !important;
  font-size: 18px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  text-align: left !important;
}

.logout-subtitle {
  color: #405261 !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 22px !important;
  text-align: left !important;
}

.logout-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #405261;

  font-size: 14px;
  padding: 40px 0;
  margin-bottom: 24px;
}

.current-session-container {
  width: 376px;
  min-height: 88px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
  margin-bottom: 8px;
  box-sizing: border-box;
}

.other-sessions-container {
  width: 376px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  margin-bottom: 15px;
  box-sizing: border-box;
}

.session-header {
  color: #061522;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  padding: 8px 16px 0px 16px;
}

.other-sessions-list {
  max-height: 225px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
  padding-bottom: 8px;
  position: relative;
  border-radius: 8px;
  background-clip: padding-box;
  scrollbar-gutter: stable;
}

.other-sessions-list::-webkit-scrollbar {
  width: 6px;
  height: 50px;
}

.other-sessions-list::-webkit-scrollbar-track {
  background: transparent;
}

.other-sessions-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  min-height: 50px;
}

.other-sessions-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.session-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0px 16px 8px 16px;
  min-height: 48px;
}

.session-icon-container {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.session-icon-container.current {
  background: #d6edff;
}

.session-icon-container.other {
  background: #f9fafa;
}

.session-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  gap: 2px;
}

.session-device-name {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.session-location {
  color: #405261;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.logout-all-sessions-button {
  width: 184px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
.logout-all-sessions-button:not(:disabled):hover {
  background-color: #ffffff;
  border-color: #c5ced6;

  outline: none;
}
.logout-current-session-button {
  width: 184px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #148dfd;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}
button.logout-current-session-button:not(:disabled):hover {
  background-color: #0077cc !important;
}
/* Scrollbar styling for other sessions */
.other-sessions-list::-webkit-scrollbar {
  width: 4px;
}

.other-sessions-list::-webkit-scrollbar-track {
  background: #f9fafa;
  border-radius: 2px;
}

.other-sessions-list::-webkit-scrollbar-thumb {
  background: #d5dce1;
  border-radius: 2px;
}

.other-sessions-list::-webkit-scrollbar-thumb:hover {
  background: #405261;
}

.sub-items-container {
  margin-left: 44px;
  margin-right: 16px;
  margin-top: 2px;
  margin-bottom: 8px;
  padding-left: 16px;
  position: relative;
  border-left: 1px solid #e5e9ec;
}

.sub-item {
  margin: 0;
  position: relative;
}

.sub-item-link {
  height: 40px !important;
  padding: 8px 16px !important;
  margin: 0px 16px !important;
  border-radius: 6px !important;
  background: transparent !important;
  transition: background-color 0.2s ease;
  display: flex !important;
  align-items: center !important;
}

.sub-item-link:hover {
  background: #f9fafa !important;
}

.sub-item-link.active {
  background: #f9fafa !important;
}

/* Blue accent line that replaces the gray connector for the active sub-item */
.sub-item .dashboard-container.sub-item-link.active::before {
  content: "";
  position: absolute;
  left: -17px;
  top: 4px;
  bottom: 4px;
  width: 2px;
  border-radius: 1px;
  background: #148dfd;
}

.sub-item-text {
  color: #405261 !important;
  font-family: Inter !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  margin: 0 !important;
  display: block !important;
  width: 100% !important;
}

.sub-item-text.active {
  color: #061522 !important;
  font-family: Inter !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 18px !important;
}

.expand-arrow {
  margin-left: auto;
  font-size: 12px;
  color: #405261;
  transition: transform 0.3s ease;
}

.expand-arrow.expanded {
  transform: rotate(180deg);
}

.dashboard-container.sub-item-link {
  background: transparent !important;
  border-radius: 6px !important;
  margin: 0 !important;
  padding: 8px 16px !important;
  height: 40px !important;
  min-height: 40px !important;
  position: relative;
}

.dashboard-container.sub-item-link.active {
  background: #f9fafa !important;
}

.dashboard-container.sub-item-link .sub-item-text {
  color: #405261 !important;
  font-family: Inter !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 18px !important;
}

.dashboard-container.sub-item-link.active .sub-item-text {
  color: #061522 !important;
  font-weight: 500 !important;
}
.MemberRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  border-radius: 8px;
  transition: 0.2s;
  margin: 0px 8px;
  cursor: pointer;
}
.member-title {
  color: #061522;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.member-email {
  color: #405261;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}

.MemberRow:hover {
  background: #f9fafa;
}
.export-button {
  width: 80px;
  height: 40px;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 6px 8px;
  text-transform: none;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  background-color: transparent;
  transition: all 0.2s ease;
}

.export-button:hover {
  border-color: #9ca3af;
  background-color: #f9fafb;
}
/* Base styles */
.Main-Header-Container {
  height: auto;
  width: 100%;
}

.Main-Chart-Container {
  height: auto;
  width: 100%;
}

.Main-chart {
  height: auto;
}

/* Desktop - 5 items per row */
@media (min-width: 1301px) {
  .Main-chart:nth-child(5n) .stat-divider {
    display: none !important;
  }
}

/* Tablet Large - 4 items per row */
@media (min-width: 1001px) and (max-width: 1300px) {
  .Main-chart:nth-child(4n) .stat-divider {
    display: none !important;
  }

  .Main-chart {
    padding: 0;
  }

  .Main-chart > div:first-child {
    padding: 14px 12px !important;
  }

  .customer_main_Text {
    font-size: 13px !important;
  }

  .number-text {
    font-size: 24px !important;
  }

  .percentage-class,
  .percentage-class-error {
    font-size: 13px !important;
  }

  .percentage-class svg,
  .percentage-class-error svg {
    width: 14px;
    height: 14px;
  }

  .week-class {
    font-size: 11px !important;
  }
}

/* Tablet - 3 items per row */
/* Base styles */
.Main-Header-Container {
  height: auto;
  width: 100%;
}

.Main-Chart-Container {
  height: auto;
  width: 100%;
}

.Main-chart {
  height: auto;
}

/* Desktop - 5 items per row */
@media (min-width: 1301px) {
  .Main-chart:nth-child(5n) .stat-divider {
    display: none !important;
  }
}

/* Tablet Large - 4 items per row */
@media (min-width: 1001px) and (max-width: 1300px) {
  .Main-chart:nth-child(4n) .stat-divider {
    display: none !important;
  }

  .Main-chart {
    padding: 0;
  }

  .Main-chart > div:first-child {
    padding: 14px 12px !important;
  }

  .customer_main_Text {
    font-size: 13px !important;
  }

  .number-text {
    font-size: 24px !important;
  }

  .percentage-class,
  .percentage-class-error {
    font-size: 13px !important;
  }

  .percentage-class svg,
  .percentage-class-error svg {
    width: 14px;
    height: 14px;
  }

  .week-class {
    font-size: 11px !important;
  }
}

/* Tablet - 3 items per row */
@media (min-width: 701px) and (max-width: 1000px) {
  .Main-chart:nth-child(3n) .stat-divider {
    display: none !important;
  }

  .Main-chart {
    padding: 0;
  }

  .Main-chart > div:first-child {
    padding: 14px 12px !important;
  }

  .customer_main_Text {
    font-size: 13px !important;
  }

  .number-text {
    font-size: 22px !important;
  }

  .percentage-class,
  .percentage-class-error {
    font-size: 12px !important;
  }

  .week-class {
    font-size: 11px !important;
  }
}

/* Mobile Large - 2 items per row */
@media (min-width: 480px) and (max-width: 700px) {
  .Main-chart:nth-child(2n) .stat-divider {
    display: none !important;
  }

  .Main-chart {
    flex: 1 1 calc(50% - 2px);
    min-width: calc(50% - 2px);
    max-width: calc(50% - 2px);
    padding: 0;
  }

  .Main-chart > div:first-child {
    padding: 10px 8px !important;
  }

  .customer_main_Text {
    font-size: 11px !important;
    margin-bottom: 4px !important;
  }

  .number-text {
    font-size: 18px !important;
  }

  .percentage-class,
  .percentage-class-error {
    font-size: 10px !important;
    gap: 2px !important;
  }

  .percentage-class svg,
  .percentage-class-error svg {
    width: 10px;
    height: 10px;
  }

  .week-class {
    font-size: 9px !important;
  }
}

/* Mobile Small - 2 items per row (compact) */
@media (max-width: 479px) {
  .Main-chart:nth-child(2n) .stat-divider {
    display: none !important;
  }

  .Main-chart {
    flex: 1 1 calc(50% - 2px);
    min-width: calc(50% - 2px);
    max-width: calc(50% - 2px);
    padding: 0;
    border-bottom: 1px solid #e5e9ec;
  }

  .Main-chart:nth-last-child(-n + 2) {
    border-bottom: none;
  }

  .Main-chart > div:first-child {
    padding: 8px 6px !important;
  }

  .customer_main_Text {
    font-size: 10px !important;
    margin-bottom: 3px !important;
    line-height: 1.3;
  }

  .number-text {
    font-size: 16px !important;
  }

  .percentage-class,
  .percentage-class-error {
    font-size: 9px !important;
    gap: 2px !important;
    margin-bottom: 1px !important;
  }

  .percentage-class svg,
  .percentage-class-error svg {
    width: 9px;
    height: 9px;
  }

  .week-class {
    font-size: 8px !important;
  }

  .chart-data {
    gap: 4px;
  }
}

/* Extra Small Mobile - 2 items per row (very compact) */
@media (max-width: 360px) {
  .Main-chart > div:first-child {
    padding: 6px 4px !important;
  }

  .customer_main_Text {
    font-size: 9px !important;
  }

  .number-text {
    font-size: 14px !important;
  }

  .percentage-class,
  .percentage-class-error {
    font-size: 8px !important;
  }

  .week-class {
    font-size: 7px !important;
  }
}

@media (max-width: 1440px) {
  .tag-Usage-Card {
    min-width: 544px !important;
  }

  /* Mobile */
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;;EAEd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qDAAqD;EACrD,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,cAAc;EACd,YAAY;EACZ,OAAO;AACT;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,UAAU;EACV,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;;EAErB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;EAC/B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,MAAM;AACR;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;;EAEjB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;;EAEhB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,MAAM;EACN,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;;EAEjD,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB,EAAE,WAAW;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb,UAAU;EACV,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oDAAoD;EACpD,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;;;GAGG;AACH;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE,qBAAqB;;EAErB,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;;EAErB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;;EAEd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD;EACnD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;;EAErB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,6BAA6B;AAC7B,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,UAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA,WAAW;AACb","sourcesContent":[".left-sidebar {\n  width: 280px;\n  height: 100vb;\n  flex-shrink: 0;\n\n  background: #fff;\n  overflow: hidden;\n  transition: width 1s ease;\n  &.closed {\n    width: 64px;\n    transition: width 1s ease;\n  }\n}\n.team-invitation-sent {\n  padding-left: 14px !important;\n}\n\n.closed-sidebar {\n  width: 80px;\n}\n.left-icon {\n  cursor: pointer;\n}\n.sidebar-content {\n  background-color: #fff;\n  height: calc(100vh - 12.5em);\n  overflow: auto;\n  padding-bottom: 20px;\n  /* scrollbar-width: none; */\n  width: 100%;\n}\n.sidebar-logo {\n  padding: 29px 32px;\n  cursor: pointer;\n}\n.side-logo {\n  width: 146.673px;\n  height: 26px;\n  flex-shrink: 0;\n}\n.inline {\n  width: 1px;\n  height: 25px;\n  background: #e5e9ec;\n  margin: 0px 24px;\n}\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.common-text {\n  color: #405261;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.dashboard-container {\n  height: 56px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0px 16px;\n  padding: 0px 16px;\n}\n.dashboard-container-mbl {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  justify-content: center;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 1, 2);\n  cursor: pointer;\n}\n.active-class {\n  display: flex;\n  height: 56px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: #f9fafa;\n  color: #061522;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  margin: 0px 16px;\n}\n.left-sidebar-mbl {\n  width: 80px;\n  height: auto;\n  flex-shrink: 0;\n  border-right: 1px solid #e5e9ec;\n  background: #fff;\n  transition: width 0.3s cubic-bezier(0.4, 0, 1, 2);\n}\n.footer-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0px 16px;\n  height: 48px;\n  padding: 0 8px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  cursor: pointer;\n}\n\n.sidebar-profile-avatar-wrap {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n}\n\n.sidebar-profile-status {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  width: 12px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n}\n\n.sidebar-profile-status svg {\n  width: 12px;\n  height: 12px;\n  display: block;\n}\n\n.footer-container .arrow {\n  margin-left: auto;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n}\n\n.footer-container-logout {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  gap: 8px;\n}\n.weilJenny-container {\n  min-width: 0;\n  flex: 1;\n}\n.weilJenny-container-logout {\n  margin-left: 0;\n  min-width: 0;\n  flex: 1;\n}\n.sidebar-footer {\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  width: 100%;\n  padding: 16px 0px;\n  position: fixed;\n  bottom: 0;\n  z-index: 1;\n  width: inherit;\n}\n.sidebar-footer-logout {\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  width: 100%;\n}\n.sidebar-footer-mbl {\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  height: 48px;\n  align-items: center;\n  margin: 0px 16px;\n}\n.jenny {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n}\n.wilson {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dashboard-header {\n  width: 100%;\n  align-items: center;\n  position: relative;\n  z-index: 100;\n}\n\n/* People: title + icon sit in main dashboard row (see .dashboard-container01--people) */\n.dashboard-container01--people .dashboard-header-left-cluster {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n.people-header-inline-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: 12px;\n  min-width: 0;\n  margin-bottom: 5px;\n}\n.people-header-inline-heading {\n  margin: 0;\n  color: #061522;\n  font-family: Inter, sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.people-dashboard-header-extension {\n  background: #fff;\n  padding: 0px 24px 0 24px;\n}\n.people-header-tabs-shell {\n  border-bottom: 1px solid #eef2f6;\n}\n.people-header-tabs-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  align-items: flex-end;\n}\n.people-header-tab-item {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #405261;\n  padding: 10px 0 11px;\n  margin-bottom: -1px;\n  border-bottom: 2px solid transparent;\n}\n.people-header-tab-item:hover {\n  color: #061522;\n}\n.people-header-tab-item-active {\n  color: #061522;\n  font-weight: 600;\n  border-bottom-color: #148dfd;\n}\n.user-detail-btn {\n  width: 144px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  margin-top: -6px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 0 15px;\n  margin-left: 16px;\n  cursor: pointer;\n}\n.user-detail-btn:not(:disabled):hover {\n  background-color: #ffffff;\n  border-color: #c5ced6;\n\n  outline: none;\n}\n.dashboard-container01 {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 24px 24px 24px;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(15px);\n}\n.right-icon {\n  display: flex;\n  align-items: center;\n  position: relative;\n  z-index: 101;\n}\n.right-icon01 {\n  align-items: center;\n  display: flex;\n  gap: 16px;\n  position: relative;\n  z-index: 101;\n}\n.right-button {\n  width: 168px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n.conv-text {\n  color: #405261;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 112.5% */\n}\n.number-con {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  background-color: #f1f3f5;\n  border-radius: 20px;\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 12px; /* 85.714% */\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.left-sidebar.closed .dashboard-container {\n  margin: 0px 8px;\n  padding: 0px 8px;\n  justify-content: center;\n  gap: 0;\n}\n.left-sidebar.closed .sidebar-logo {\n  padding: 29px 8px;\n  display: flex;\n  justify-content: center;\n}\n.dashboard-container.active {\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: #f9fafa;\n  height: 56px;\n  cursor: pointer;\n  margin: 0px 16px;\n  padding: 0px 16px;\n}\n.common-text.active {\n  color: #061522;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.dashboard-container-mbl.active {\n  background-color: #e0e0e0;\n  color: #007bff;\n}\n\n.Main-Chart-Container {\n  display: flex;\n  height: 120px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n}\n\n.overview_main {\n  color: #061522;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.Main-Header-Container {\n  height: 120px;\n}\n.Main-chart {\n  height: 120px;\n  /* padding: 16px 24px; */\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  /* border-right: 1px solid #e5e9ec; */\n}\n.Dot {\n  border-radius: 50px;\n  background: #148dfd;\n  width: 8px;\n  height: 8px;\n  flex-shrink: 0;\n}\n\n.customer_main_Text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin-left: 2px;\n}\n.number-text {\n  color: #061522;\n  font-size: 44px;\n  line-height: 54px;\n  font-style: normal;\n  font-weight: 500;\n}\n.chart-data {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 22px;\n  align-items: center;\n}\n.percentage-class {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  color: #148dfd;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.percentage-class-error {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  color: red;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.week-class {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n}\n\n/* chartStyles.css */\n.chart-container {\n  background-color: lightblue;\n}\n\n.stacked-chart-container {\n  background-color: lightgreen;\n}\n.NewChat-Container {\n  width: 50%;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 20px;\n}\n.NewEmail-Container {\n  flex-shrink: 0;\n  width: 50%;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 20px;\n}\n.userchat-name {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.user-chat {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.timeclass {\n  color: #061522;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 150% */\n}\n.NewChat-text {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.BaseText {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n}\n.ViewText {\n  color: #148dfd;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n.newChat-text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.chatBottom {\n  /* width: 496px; */\n  height: 1px;\n  margin-right: 10px;\n  background: #e5e9ec;\n}\n.newChat-li {\n  display: flex;\n  list-style-type: none;\n  padding: 16px 10px;\n  align-items: center;\n}\n.arrow {\n  transition: transform 0.3s ease;\n}\n\n.rotate-arrow {\n  transform: rotate(180deg);\n}\n.Knwoledge-li {\n  display: flex;\n  list-style-type: none;\n  padding: 16px 10px;\n  align-items: center;\n}\n.Knwoledge-name {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.Knwoledge-text {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n}\n.user-description {\n  margin: 14px 0px;\n}\n.text-description {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.newEmail-li {\n  display: flex;\n  list-style-type: none;\n  padding: 16px 0px;\n  margin-right: 10px;\n}\n.UserNameChat {\n  display: flex;\n  flex-direction: column;\n}\n.UserNameEmail {\n  display: flex;\n  flex-direction: column;\n}\n\n.UserMainChat {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-left: 8px;\n  margin-top: 5px;\n}\n.UserMainEmail {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-left: 8px;\n  margin-top: 5px;\n}\n.UserMainknowledge-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-left: 8px;\n  margin-top: 5px;\n  align-items: center;\n}\n.Knowledge-container {\n  width: 50%;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 20px;\n}\n.knowledge-container01 {\n  margin-top: 27px;\n  border-bottom: 1px solid #e5e9ec;\n}\n.table-head {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 9px;\n}\n\n.table-text {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.table-modified {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin-left: 140px;\n}\n\n.table-text modified {\n  margin-left: 20px;\n}\n\n.css-sxh3gq-MuiAvatar-root-MuiAvatarGroup-avatar {\n  background-color: #d6edff !important;\n  color: #148dfd !important;\n}\n\n.Customer-satisfication {\n  width: 100%;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n  flex-grow: 1;\n}\n.customer-text {\n  display: flex;\n  justify-content: space-between;\n}\n.customer_heading {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n}\n.last-message-text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.customer-link {\n  color: #148dfd;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  text-decoration-line: underline;\n}\n.Circular-bar {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  height: 20vh;\n  overflow: auto;\n}\n.circle-text {\n  color: #405261;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  margin-top: 8px;\n}\n\n.LinearProgress-container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n  flex-grow: 1;\n}\n.ticket-container {\n  display: flex;\n  justify-content: space-between;\n}\n.Dot {\n  border-radius: 50px;\n  background-color: #007bff;\n  width: 8px;\n  height: 8px;\n}\n.linearProgressBar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px; /* 116.667% */\n  margin-top: 18px;\n  margin-bottom: 9px;\n}\n.LinearText {\n  color: #061522;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n.issues-text {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.viewIssues-text {\n  color: #148dfd;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  text-decoration-line: underline;\n}\n.statusButton-open {\n  border-radius: 5px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  padding: 4px 8px;\n  flex-shrink: 0;\n  text-align: center;\n}\n.statusButton-close {\n  border-radius: 5px;\n  border: 1px solid #ff4d4f;\n  background: #fff1f0;\n  padding: 4px 8px;\n  flex-shrink: 0;\n  text-align: center;\n}\n.statusButton-pending {\n  border-radius: 5px;\n  border: 1px solid #fadb14;\n  background: #fffbe6;\n  padding: 4px 12px;\n  flex-shrink: 0;\n  text-align: center;\n}\n.jacob-class {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.jacob-text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.jacob-des {\n  color: #556575;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.jacob-container {\n  display: flex;\n  flex-direction: column;\n}\n.jones-container {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.devon-lane {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.Header-cell {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.Ticket-Section-Container {\n  width: 100%;\n  margin: 0px 0px;\n  padding: 0px 24px;\n\n  /* height: calc(100vh - 15.5em); */\n  display: flex;\n  flex-direction: column;\n  /* height: calc(100vh - 21.3em); */\n}\n.Team-Section-Content-Container {\n  /* margin: 38px 0px; */\n  /* height: calc(100vh - 18.3em); */\n  overflow-y: auto;\n}\n.Team-main-table-container {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.table-header-cell {\n  text-align: left;\n  border-bottom: 1px solid #e5e9ec;\n}\n.team-table-img {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.table-header-cell th {\n  padding-bottom: 9px;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.dashboardheader-right-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tbodyClass01 tr:hover {\n  border-collapse: collapse;\n  border-spacing: 0;\n  background-color: #f9fafa;\n}\n.team-table-tr td {\n  padding: 16px 0;\n  border-bottom: 1px solid #e5e9ec;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  position: relative;\n  cursor: pointer;\n}\n.users-table-tr td {\n  width: 19%;\n}\n.ticket-table-tr td {\n  padding: 16px 0px;\n  border-bottom: 1px solid #e5e9ec;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  position: relative;\n  cursor: pointer;\n}\n.team-table-rowtext {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.team-activeuser {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #061522;\n  font-weight: 500;\n\n  cursor: pointer;\n}\n.team-table-menu {\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n.team-main-menu-container {\n  position: fixed;\n  width: 184px;\n  right: 30px;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  max-height: 300px;\n  /* overflow-y: auto;  */\n  padding: 25px;\n}\n.menu-viewprofile {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n}\n\n.Team-Main-SideBar {\n  position: fixed;\n  right: 0px;\n  top: 0;\n  width: 33em;\n  height: 100vh;\n  /* overflow: auto; */\n  background: #fff;\n  box-shadow: 0px 4px 80px 0px rgba(6, 21, 34, 0.1);\n  padding: 32px;\n  transition: transform 0.3s ease;\n  z-index: 9999;\n}\n\n.Team-Main-SideBar--open {\n  transform: translateX(0);\n}\n.Team-Main-SideBar--closed {\n  transform: translateX(-100%);\n}\n.SideBar-Content-Container {\n  max-height: calc(100vh - 260px);\n  overflow: auto;\n}\n\n.GroupSide-Content-Container {\n  max-height: calc(100vh - 200px);\n  overflow: auto;\n}\n.detail-text {\n  color: #061522;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.Team-SideBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.Team-sidebar-profile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 32px 0px;\n}\n.Team-sidebar-profile-group {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 24px 0px;\n}\n.Team-logo-profile {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.Team-logo-profile-group {\n  display: flex;\n  align-items: center;\n  gap: 17px;\n}\n.agent-button {\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  border-radius: 5px;\n  height: 24px;\n  min-width: 64px;\n  padding: 0px 2px;\n  /* width: 100%; */\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n\n  cursor: pointer;\n}\n\n.agent-button:not(:disabled):hover {\n  border-color: #c5ced6;\n  outline: none;\n}\n.Robert-Fox {\n  color: #061522;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  text-transform: capitalize;\n  line-height: 18px; /* 112.5% */\n}\n.TeamClose-btn {\n  cursor: pointer;\n}\n.Nathan-Fox {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.profile-linestyle {\n  border-bottom: 1px solid #e5e9ec;\n  background: #fff;\n  width: 100%;\n}\n.team-profile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 15px;\n}\n.team-profile-list {\n  display: flex;\n  gap: 8px;\n  cursor: pointer;\n  padding-bottom: 8px;\n}\n.profile-header-text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.ProfileActive {\n  color: #148dfd;\n  border-bottom: 1px solid #148dfd;\n  cursor: pointer;\n  padding-bottom: 8px;\n}\n.ProfileActive .profile-header-text {\n  color: #148dfd;\n}\n.AccountType-Main-Container {\n  margin-top: 41px;\n}\n.AccountType-Main-Container01 {\n  margin-top: 26px;\n}\n.AccountType-content {\n  display: flex;\n  align-items: center;\n  padding: 12px 0px;\n}\n\n.Account-Type01 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 50%;\n}\n.AccountType-text {\n  color: #405261;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 112.5% */\n}\n.AccountAgent-text {\n  color: #061522;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 112.5% */\n}\n.TicketTag {\n  border-radius: 16px;\n  border: 1px solid #c5ced6;\n  background: #f9fafa;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 8px;\n  color: #405261;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 12px;\n}\n.SuperVisor-Main-Container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n}\n.SuperVisor-Header-text {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.SuperVisorText {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n}\n.SuperVisorChange {\n  color: #148dfd;\n  text-align: right;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  cursor: pointer;\n}\n\n.CC-Remove {\n  color: #ff4d4f;\n  text-align: right;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  cursor: pointer;\n}\n\n.SuperVisor-Logo-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 22px;\n}\n.Super-Robert-text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.Super-Kenzi-text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.SuperVisor-Container {\n  margin-top: 32px;\n}\n.AssignChat-Main-Container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n}\n.AssignChat-Header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.AssignChat-text {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n}\n.AssignChat-View {\n  color: #148dfd;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n.TeamAssign-Container {\n  margin-top: 30px;\n}\n\n.Assign-Chat-Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 22px;\n}\n.AssignChat-button {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 30px;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n\n.AssignChat-button:not(.Mui-disabled):hover {\n  border-color: #c5ced6;\n  outline: none;\n}\n.AssignChat-status {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.AssignChat-Style {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.AssginKatryn-Text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.AssingKenzi-Text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n\n.TableView {\n  display: flex;\n  justify-content: center;\n  margin-top: 40px;\n}\n.view-more-text {\n  color: #148dfd;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n.Active-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 144px;\n  padding: 9px 16px;\n  cursor: pointer;\n}\n.dropdown-container {\n  position: relative;\n  display: inline-block;\n}\n\n.Active-btn:hover {\n  background-color: #f9fafa;\n}\n\n.dropdown-content {\n  position: absolute;\n  top: 120%;\n  right: 1%;\n  width: 184px;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 8px 11px;\n  z-index: 1;\n}\n.dropdown-content-table {\n  position: absolute;\n  right: 50%;\n  width: 184px;\n  top: 80%;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 8px 11px;\n  z-index: 1;\n}\n.dropdown-content-table-active {\n  position: absolute;\n  /* right: 40%; */\n  width: 184px;\n  top: 80%;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 8px 11px;\n  z-index: 1;\n}\n\n.dropdown-content-table:hover {\n  background: #fff;\n}\n\n.dropdown-content ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.dropdown-content-table ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.dropdown-content-table ul li {\n  padding: 9px 10px;\n  cursor: pointer;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.dropdown-content-table ul:hover {\n  background: #fff;\n}\n.dropdown-content ul li {\n  padding: 9px 10px;\n  cursor: pointer;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.dropdown-content ul li:hover {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  background: #f9fafa;\n  color: #061522;\n}\n.dropdown-content-table ul li:hover {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  background: #f9fafa;\n  color: #061522;\n}\n\n.Active-btn:hover + .dropdown-content {\n  display: block;\n}\n.Active-popup-container {\n  position: absolute;\n  z-index: 1;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 24px;\n  width: 32%;\n  height: auto;\n  z-index: 1;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n}\n\n.Confirm-text {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n}\n.Save-active-text {\n  margin-top: 5px;\n  color: #556575;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n}\n\n.active-popup-button {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 64px;\n  align-items: center;\n  gap: 8px;\n}\n.active-cancel-button {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 42px;\n  color: #405261;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.active-confirm-button {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 11px 42px;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.Team-Group-Main-Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 11px;\n}\n.Team-Group-Heading {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n}\n.Team-Group-Link {\n  color: #148dfd;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  text-decoration-line: underline;\n}\n\n.Team-Group-Main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0px;\n}\n.Team-Group-logo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.group-title01 {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.TeamGroup-Container {\n  margin-top: 30px;\n}\n.hash-container {\n  display: flex;\n  flex-direction: column;\n}\n.grouphas-button {\n  border-radius: 5px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  width: 48px;\n  height: 27px;\n  color: #405261;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 150% */\n}\n.hashtext {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  margin-bottom: 3px;\n}\n.hashtitle {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.tickettime {\n  color: #405261;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.Team-Ticket-Main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 21px 0px;\n}\n\n.Team-Ticket01 {\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n}\n.WorkingText {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n  margin-bottom: 22px;\n}\n.Team-Working-Main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.wokringtitle {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.workingtime {\n  color: #405261;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.Team-Working-Main {\n  padding: 7px 0px;\n}\n.Group-Main-Container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n}\n.TeamTicket-Main-Container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n}\n.TeamWorking-main-container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  padding: 24px;\n}\n.group-discreption {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.Group-logo-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.viewmore-logo {\n  background: #d6edff;\n  border-radius: 20px;\n  text-align: center;\n  stroke: #fff;\n  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.05));\n  width: 40px;\n  height: 40px;\n  padding: 5px;\n  color: #148dfd;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n/* .groupIcon{\n  display: flex;\n  max-width: 75px;\n} */\n#tags-outlined {\n  padding: 6px;\n}\n.borderedActive {\n  outline: solid 2px;\n  outline-color: #1976d2;\n}\n.MuiOutlinedInput-root {\n  /* margin-top: 8px; */\n  border-radius: 8px;\n}\n#multiple-limit-tags {\n  padding: 6px;\n}\n.AutoInput {\n  background: #007bff;\n  border-radius: 20px;\n  /* border: 1px solid #D5DCE1; */\n  background: #fff;\n  /* box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05); */\n}\n.AutoInput ::placeholder {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.ChatLimit-Container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 29px;\n}\n.Chatselect-Input {\n  margin-top: 20px;\n}\n.chatKatryn {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.chatkenzi {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.chatLimit-button {\n  display: flex;\n  gap: 15px;\n  margin-top: 32px;\n}\n.SendChat-Button {\n  margin: auto;\n  width: 50%;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.SendChat-Button:not(:disabled):hover,\n.SendChat-Button:not(:disabled):focus-visible {\n  border-color: #c5ced6;\n\n  outline: none;\n}\n.SendChat-Button01 {\n  margin: auto;\n  width: 50%;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n\n.SendChat-Button01:hover:not(.Mui-disabled):not(:disabled) {\n  background-color: #0077cc;\n}\n\n.Team-total-active-user {\n  color: #061522;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 100% */\n  margin-bottom: 22px;\n  display: none;\n}\n\n.Delete-group-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.DeleteFile-text {\n  margin-top: 28px;\n  color: #061522;\n  text-align: center;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.DeleteFile-text01 {\n  color: #556575;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin-top: 8px;\n  width: 80%;\n}\n.Deletegroup-delete-container {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 24px;\n}\n.Deletegroup-cancel01 {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 100%;\n  height: 40px;\n  cursor: pointer;\n}\n.Deletegroup-cancel01:not(:disabled):hover {\n  background-color: #ffffff;\n  border-color: #c5ced6;\n\n  outline: none;\n}\n.Deletegroup-delete01 {\n  border-radius: 8px;\n  background: #148dfd;\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 100%;\n  height: 40px;\n  border: none;\n  cursor: pointer;\n}\nbutton.Deletegroup-delete01:not(:disabled):hover {\n  background-color: #0077cc !important;\n}\n#long-button:focus {\n  border-color: red;\n}\n\n.Logout-Menu-Container {\n  border-radius: 8px;\n  border: 1px solid #e5e9ec;\n  background: #fff;\n  box-shadow: none;\n  padding: 16px;\n  position: fixed;\n  left: 16px;\n  bottom: 80px;\n  width: 256px;\n  box-sizing: border-box;\n  z-index: 9999 !important;\n}\n.Logout-switch-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 25px;\n}\n.switch-class {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  cursor: pointer;\n}\n.switch-class:hover {\n  color: #061522;\n}\n\n.Logout-switch-Dark {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 16px;\n}\n.LineClass {\n  margin: 17px 0px;\n  border: 1px solid #e5e9ec;\n  width: 100%;\n  margin: 16px 0px;\n}\n.LogoutText {\n  color: #ff4d4f;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  cursor: pointer;\n}\n.Switch-Main-Container {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.NoSuspendedAgent-main-Conatiner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: calc(100vh - 25.7em);\n}\n\n.Space-Left {\n  margin-left: 8px;\n  font-weight: 500;\n}\n\n.popup-content-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.header-section {\n  margin-bottom: 16px;\n}\n\n.logout-main-title {\n  color: #061522 !important;\n  font-size: 18px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  text-align: left !important;\n}\n\n.logout-subtitle {\n  color: #405261 !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: 22px !important;\n  text-align: left !important;\n}\n\n.logout-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #405261;\n\n  font-size: 14px;\n  padding: 40px 0;\n  margin-bottom: 24px;\n}\n\n.current-session-container {\n  width: 376px;\n  min-height: 88px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n  margin-bottom: 8px;\n  box-sizing: border-box;\n}\n\n.other-sessions-container {\n  width: 376px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n}\n\n.session-header {\n  color: #061522;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n  padding: 8px 16px 0px 16px;\n}\n\n.other-sessions-list {\n  max-height: 225px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 8px;\n  padding-bottom: 8px;\n  position: relative;\n  border-radius: 8px;\n  background-clip: padding-box;\n  scrollbar-gutter: stable;\n}\n\n.other-sessions-list::-webkit-scrollbar {\n  width: 6px;\n  height: 50px;\n}\n\n.other-sessions-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.other-sessions-list::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  min-height: 50px;\n}\n\n.other-sessions-list {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n}\n\n.session-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0px 16px 8px 16px;\n  min-height: 48px;\n}\n\n.session-icon-container {\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.session-icon-container.current {\n  background: #d6edff;\n}\n\n.session-icon-container.other {\n  background: #f9fafa;\n}\n\n.session-details {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  gap: 2px;\n}\n\n.session-device-name {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n}\n\n.session-location {\n  color: #405261;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.logout-all-sessions-button {\n  width: 184px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\n.logout-all-sessions-button:not(:disabled):hover {\n  background-color: #ffffff;\n  border-color: #c5ced6;\n\n  outline: none;\n}\n.logout-current-session-button {\n  width: 184px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  background: #148dfd;\n  color: #fff;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n}\nbutton.logout-current-session-button:not(:disabled):hover {\n  background-color: #0077cc !important;\n}\n/* Scrollbar styling for other sessions */\n.other-sessions-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.other-sessions-list::-webkit-scrollbar-track {\n  background: #f9fafa;\n  border-radius: 2px;\n}\n\n.other-sessions-list::-webkit-scrollbar-thumb {\n  background: #d5dce1;\n  border-radius: 2px;\n}\n\n.other-sessions-list::-webkit-scrollbar-thumb:hover {\n  background: #405261;\n}\n\n.sub-items-container {\n  margin-left: 44px;\n  margin-right: 16px;\n  margin-top: 2px;\n  margin-bottom: 8px;\n  padding-left: 16px;\n  position: relative;\n  border-left: 1px solid #e5e9ec;\n}\n\n.sub-item {\n  margin: 0;\n  position: relative;\n}\n\n.sub-item-link {\n  height: 40px !important;\n  padding: 8px 16px !important;\n  margin: 0px 16px !important;\n  border-radius: 6px !important;\n  background: transparent !important;\n  transition: background-color 0.2s ease;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.sub-item-link:hover {\n  background: #f9fafa !important;\n}\n\n.sub-item-link.active {\n  background: #f9fafa !important;\n}\n\n/* Blue accent line that replaces the gray connector for the active sub-item */\n.sub-item .dashboard-container.sub-item-link.active::before {\n  content: \"\";\n  position: absolute;\n  left: -17px;\n  top: 4px;\n  bottom: 4px;\n  width: 2px;\n  border-radius: 1px;\n  background: #148dfd;\n}\n\n.sub-item-text {\n  color: #405261 !important;\n  font-family: Inter !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: 18px !important;\n  margin: 0 !important;\n  display: block !important;\n  width: 100% !important;\n}\n\n.sub-item-text.active {\n  color: #061522 !important;\n  font-family: Inter !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: 18px !important;\n}\n\n.expand-arrow {\n  margin-left: auto;\n  font-size: 12px;\n  color: #405261;\n  transition: transform 0.3s ease;\n}\n\n.expand-arrow.expanded {\n  transform: rotate(180deg);\n}\n\n.dashboard-container.sub-item-link {\n  background: transparent !important;\n  border-radius: 6px !important;\n  margin: 0 !important;\n  padding: 8px 16px !important;\n  height: 40px !important;\n  min-height: 40px !important;\n  position: relative;\n}\n\n.dashboard-container.sub-item-link.active {\n  background: #f9fafa !important;\n}\n\n.dashboard-container.sub-item-link .sub-item-text {\n  color: #405261 !important;\n  font-family: Inter !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: 18px !important;\n}\n\n.dashboard-container.sub-item-link.active .sub-item-text {\n  color: #061522 !important;\n  font-weight: 500 !important;\n}\n.MemberRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 72px;\n  border-radius: 8px;\n  transition: 0.2s;\n  margin: 0px 8px;\n  cursor: pointer;\n}\n.member-title {\n  color: #061522;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n.member-email {\n  color: #405261;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n\n.MemberRow:hover {\n  background: #f9fafa;\n}\n.export-button {\n  width: 80px;\n  height: 40px;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  padding: 6px 8px;\n  text-transform: none;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  background-color: transparent;\n  transition: all 0.2s ease;\n}\n\n.export-button:hover {\n  border-color: #9ca3af;\n  background-color: #f9fafb;\n}\n/* Base styles */\n.Main-Header-Container {\n  height: auto;\n  width: 100%;\n}\n\n.Main-Chart-Container {\n  height: auto;\n  width: 100%;\n}\n\n.Main-chart {\n  height: auto;\n}\n\n/* Desktop - 5 items per row */\n@media (min-width: 1301px) {\n  .Main-chart:nth-child(5n) .stat-divider {\n    display: none !important;\n  }\n}\n\n/* Tablet Large - 4 items per row */\n@media (min-width: 1001px) and (max-width: 1300px) {\n  .Main-chart:nth-child(4n) .stat-divider {\n    display: none !important;\n  }\n\n  .Main-chart {\n    padding: 0;\n  }\n\n  .Main-chart > div:first-child {\n    padding: 14px 12px !important;\n  }\n\n  .customer_main_Text {\n    font-size: 13px !important;\n  }\n\n  .number-text {\n    font-size: 24px !important;\n  }\n\n  .percentage-class,\n  .percentage-class-error {\n    font-size: 13px !important;\n  }\n\n  .percentage-class svg,\n  .percentage-class-error svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .week-class {\n    font-size: 11px !important;\n  }\n}\n\n/* Tablet - 3 items per row */\n/* Base styles */\n.Main-Header-Container {\n  height: auto;\n  width: 100%;\n}\n\n.Main-Chart-Container {\n  height: auto;\n  width: 100%;\n}\n\n.Main-chart {\n  height: auto;\n}\n\n/* Desktop - 5 items per row */\n@media (min-width: 1301px) {\n  .Main-chart:nth-child(5n) .stat-divider {\n    display: none !important;\n  }\n}\n\n/* Tablet Large - 4 items per row */\n@media (min-width: 1001px) and (max-width: 1300px) {\n  .Main-chart:nth-child(4n) .stat-divider {\n    display: none !important;\n  }\n\n  .Main-chart {\n    padding: 0;\n  }\n\n  .Main-chart > div:first-child {\n    padding: 14px 12px !important;\n  }\n\n  .customer_main_Text {\n    font-size: 13px !important;\n  }\n\n  .number-text {\n    font-size: 24px !important;\n  }\n\n  .percentage-class,\n  .percentage-class-error {\n    font-size: 13px !important;\n  }\n\n  .percentage-class svg,\n  .percentage-class-error svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .week-class {\n    font-size: 11px !important;\n  }\n}\n\n/* Tablet - 3 items per row */\n@media (min-width: 701px) and (max-width: 1000px) {\n  .Main-chart:nth-child(3n) .stat-divider {\n    display: none !important;\n  }\n\n  .Main-chart {\n    padding: 0;\n  }\n\n  .Main-chart > div:first-child {\n    padding: 14px 12px !important;\n  }\n\n  .customer_main_Text {\n    font-size: 13px !important;\n  }\n\n  .number-text {\n    font-size: 22px !important;\n  }\n\n  .percentage-class,\n  .percentage-class-error {\n    font-size: 12px !important;\n  }\n\n  .week-class {\n    font-size: 11px !important;\n  }\n}\n\n/* Mobile Large - 2 items per row */\n@media (min-width: 480px) and (max-width: 700px) {\n  .Main-chart:nth-child(2n) .stat-divider {\n    display: none !important;\n  }\n\n  .Main-chart {\n    flex: 1 1 calc(50% - 2px);\n    min-width: calc(50% - 2px);\n    max-width: calc(50% - 2px);\n    padding: 0;\n  }\n\n  .Main-chart > div:first-child {\n    padding: 10px 8px !important;\n  }\n\n  .customer_main_Text {\n    font-size: 11px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .number-text {\n    font-size: 18px !important;\n  }\n\n  .percentage-class,\n  .percentage-class-error {\n    font-size: 10px !important;\n    gap: 2px !important;\n  }\n\n  .percentage-class svg,\n  .percentage-class-error svg {\n    width: 10px;\n    height: 10px;\n  }\n\n  .week-class {\n    font-size: 9px !important;\n  }\n}\n\n/* Mobile Small - 2 items per row (compact) */\n@media (max-width: 479px) {\n  .Main-chart:nth-child(2n) .stat-divider {\n    display: none !important;\n  }\n\n  .Main-chart {\n    flex: 1 1 calc(50% - 2px);\n    min-width: calc(50% - 2px);\n    max-width: calc(50% - 2px);\n    padding: 0;\n    border-bottom: 1px solid #e5e9ec;\n  }\n\n  .Main-chart:nth-last-child(-n + 2) {\n    border-bottom: none;\n  }\n\n  .Main-chart > div:first-child {\n    padding: 8px 6px !important;\n  }\n\n  .customer_main_Text {\n    font-size: 10px !important;\n    margin-bottom: 3px !important;\n    line-height: 1.3;\n  }\n\n  .number-text {\n    font-size: 16px !important;\n  }\n\n  .percentage-class,\n  .percentage-class-error {\n    font-size: 9px !important;\n    gap: 2px !important;\n    margin-bottom: 1px !important;\n  }\n\n  .percentage-class svg,\n  .percentage-class-error svg {\n    width: 9px;\n    height: 9px;\n  }\n\n  .week-class {\n    font-size: 8px !important;\n  }\n\n  .chart-data {\n    gap: 4px;\n  }\n}\n\n/* Extra Small Mobile - 2 items per row (very compact) */\n@media (max-width: 360px) {\n  .Main-chart > div:first-child {\n    padding: 6px 4px !important;\n  }\n\n  .customer_main_Text {\n    font-size: 9px !important;\n  }\n\n  .number-text {\n    font-size: 14px !important;\n  }\n\n  .percentage-class,\n  .percentage-class-error {\n    font-size: 8px !important;\n  }\n\n  .week-class {\n    font-size: 7px !important;\n  }\n}\n\n@media (max-width: 1440px) {\n  .tag-Usage-Card {\n    min-width: 544px !important;\n  }\n\n  /* Mobile */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
